import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {Col, Row, Button, Image} from 'react-bootstrap'
import {FaMagnet} from '../Common/ReactIcons/icons'
import { PersianNumber } from 'react-persian'
import ProgressBar from '../Common/ProgressBar/ProgressBar'

import './Layout/Store.css'

class HorseshoeBox extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: false
    }
  }
  selectItem (id) {
    if (this.state.isLoading) {
      return false
    }

    if (!this.props.isAuthenticated) {
      return Actions.toggleLoginBox(true)
    }

    this.setState({isLoading: true})

    Actions.buy({items: [{product_id: id, count: 1}]}).then((data) => {
      window.location = data.redirectUrl
      this.setState({isLoading: false})
    })
  }

  render () {
    const { horseshoe } = this.props
    const { isLoading } = this.state
    return (
      <Col xs={12} sm={6} md={4} lg={3} className="horseshoe-box" onClick={() => this.selectItem(horseshoe.id)}>
        <Row>
          <Col xs={12}>
            <h3 className="title">{horseshoe.title}</h3>
          </Col>
        </Row>
        <Row>
          <Image src={horseshoe.image} alt="" className="image" />
        </Row>
        <Row>
          <Col xs={12}>
            <h4 className="count"><FaMagnet /> <PersianNumber>{horseshoe.attributes.point}</PersianNumber></h4>
            <Button className={`price btnBlock ${isLoading && 'disabled'}`} bsStyle="primary"><PersianNumber>{(horseshoe.price > 1000) ? `${horseshoe.price / 1000} هزار` : horseshoe.price} تومان</PersianNumber></Button>
            <ProgressBar isLoading={isLoading} type="button" />
          </Col>
        </Row>
      </Col>
    )
  }
}

HorseshoeBox.propTypes = {
  horseshoe: React.PropTypes.object.isRequired,
  isAuthenticated: React.PropTypes.bool
}

export default HorseshoeBox



// WEBPACK FOOTER //
// ./src/components/Store/HorseshoeBox.js